import { Component, OnInit, ViewContainerRef, OnChanges, SimpleChanges, EventEmitter, Output, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModalDialogService } from 'ngx-modal-dialog';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';
import { Privacy } from '../../../models/privacy';
import {AlgPrivacyModalComponent} from '../../dialogs/alg-privacy-modal/alg-privacy-modal.component';
import { UtilsService } from '../../../services/utils.service';
import { AlgFisicoService } from '../../../services/alg-fisico.service';
import { PhysicApprovalPrivacyConsents } from '../../../services/alg-fisico.service.d';

const privacyData = require('../../../data/privacy.json');


@Component({
  selector: 'alg-fisico-personal-data',
  templateUrl: './alg-fisico-personal-data.component.html',
  styleUrls: ['./alg-fisico-personal-data.component.scss']
})
export class AlgFisicoPersonalDataComponent implements OnInit, OnDestroy {
  public informativeNoteUrl = '';
  public privacyForm: FormGroup;

  public privacyOptions = [{
    label: 'Do il consenso',
    value: 'true'
  }, {
    label: 'Nego il consenso',
    value: 'false'
  }];

  public privacyItems: any;

  public variablePrivacy = {
    commercialiALG: {
      value: ''
    },
  };
  private ngUnsubscribe = new Subject<void>();
  private privacyFieldsMap = new Map([
    ['commercialiALG', 'privacyComCom'],
  ]);

  constructor(
    private fisicoService: AlgFisicoService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit() {
    // SUBSCRIBE: save general privacy policy url
    this.fisicoService.policiesUrl$
      .pipe(
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((policiesUrls) => {
        this.informativeNoteUrl = policiesUrls.generalPolicy;
      });

    this.privacyForm = new FormGroup({
      commercialiALG: new FormControl(this.variablePrivacy.commercialiALG, {
        validators: [Validators.required]
      }),
    });

    this.privacyForm.valueChanges.subscribe(data => {
      const mappedData = this.transformPrivacyConsents(data);
      this.fisicoService.updatePrivacyConsents({
        valid: this.privacyForm.status === 'VALID',
        data: mappedData
      });
    });
    privacyData['commercialiALG']['id'] = 'commercialiALG';
    this.privacyItems = [privacyData['commercialiALG']]
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  openModal(modalContent) {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: modalContent.title,
      childComponent: AlgPrivacyModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline'
      },
      data: {
        description: modalContent.description
      }
    });
  }

  public readPrivacy(type) {
    let modalContent;
    switch (type) {
      case 'commercialiALG':
        modalContent = Privacy('commercialiALG');
        break;
      // case 'profilazioneALG':
      //   modalContent = Privacy('profilazioneALG');
      //   break;
      // case 'qualità':
      //   modalContent = Privacy('qualità');
      //   break;
      // case 'commercialiTerzi':
      //   modalContent = Privacy('commercialiTerzi');
      //   break;
      // default:
      //   modalContent = Privacy('profilazioneTerzi');
      default:
        modalContent = Privacy('commercialiALG');
    }
    this.openModal(modalContent || {});
  }

  private transformPrivacyConsents(consents): PhysicApprovalPrivacyConsents {
    return Object.keys(consents || {})
      .reduce((acc, key) => {
        const mappedKey = this.privacyFieldsMap.get(key);
        if (!mappedKey) { return acc; }
        return {
          ...acc,
          [mappedKey]: consents[key]
        };
      }, {}) as PhysicApprovalPrivacyConsents;
  }

}


// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-fisico-personal-data/alg-fisico-personal-data.component.ts